import { Avatar, Box, HStack, Text } from "@chakra-ui/react"

export default function Comment({ data }){
    return(
    <HStack spacing={4}  padding="12px 18px" borderRadius={8} boxShadow="4px 4px 10px rgba(0,0,0,0.1)">
        <Avatar size="sm" name={data.employee.name} />
        <Box>
            <Text fontSize="xs" color="GrayText" children={`${data.employee.name} comentou:`} />
            <Text fontSize="sm" children={data.body} />
        </Box>
    </HStack>
    )
}